import { withRehydration } from './withRehydration';
import {
  FETCH_ANCILLARIES_FAILED,
  FETCH_ANCILLARIES_LOADING,
  FETCH_ANCILLARIES_SUCCEEDED,
  type FetchingAncillaries,
  type FetchingAncillariesFailed,
  type FetchingAncillariesSucceeded,
} from '~shared/actions/ancillaries';
import { type PrescriptionsWithAncillaries } from '~shared/features/my-meds/types';
import { type APIError } from '~shared/types';

export type AncillariesState = {
  ancillaries: PrescriptionsWithAncillaries;
  lastRequestAttemptedAt: number;
  requestAttemptCount: number;
  error?: APIError;
};

type Action = FetchingAncillaries | FetchingAncillariesFailed | FetchingAncillariesSucceeded;

const initialState: AncillariesState = {
  ancillaries: {},
  lastRequestAttemptedAt: 0,
  requestAttemptCount: 0,
};

const existsInState = (stateAncillaries: PrescriptionsWithAncillaries, prescriptionID: string) => {
  return !!Object.getOwnPropertyDescriptor(stateAncillaries, prescriptionID);
};

const ancillaries = (state: AncillariesState = initialState, action: Action): AncillariesState => {
  switch (action.type) {
    case FETCH_ANCILLARIES_LOADING:
      return { ...state, lastRequestAttemptedAt: Date.now(), requestAttemptCount: state.requestAttemptCount + 1 };

    case FETCH_ANCILLARIES_SUCCEEDED: {
      const { payload } = action;
      /* If prescription ID exists, it's going to be updated,
          if not, it's going to be added to the ancillaries state */
      const prescriptionID = Object.keys(payload)[0];

      if (existsInState(state.ancillaries, prescriptionID)) {
        const ancillariesUpdated = { ...state.ancillaries };
        ancillariesUpdated[prescriptionID] = payload[prescriptionID];
        return {
          ...state,
          ancillaries: ancillariesUpdated,
          lastRequestAttemptedAt: Date.now(),
          requestAttemptCount: state.requestAttemptCount + 1,
        };
      }

      return {
        ...state,
        ancillaries: { ...state.ancillaries, ...payload },
        lastRequestAttemptedAt: Date.now(),
        requestAttemptCount: state.requestAttemptCount + 1,
      };
    }

    case FETCH_ANCILLARIES_FAILED: {
      const { payload } = action;
      return {
        ...state,
        error: payload,
        lastRequestAttemptedAt: Date.now(),
        requestAttemptCount: state.requestAttemptCount + 1,
      };
    }
    default:
      return state;
  }
};

export default withRehydration(ancillaries, initialState);
